import { IHocSinhSearchRequest } from "../../model/request/hoc-sinh/IHocSinhSearchRequest";
import { ISelectParentEmailsRequest } from "../../model/request/hoc-sinh/ISelectParentEmailsRequest";
import { apiClient, formatQueryString } from "../apiClient";

export interface IHocSinhListRequest {
    nam_hoc: string;
    dm_coso_id: number;
}

export const hocSinhApi = {
    Search: (request: IHocSinhSearchRequest) => apiClient.get(`hoc-sinh/search?${formatQueryString(request)}`),
    SearchHocSinh: (request: IHocSinhListRequest) => apiClient.post(`hoc-sinh/search-hoc-sinh`, request),
    SelectParentEmails: (request: ISelectParentEmailsRequest) => apiClient.get(`hoc-sinh/select-parent-emails?${formatQueryString(request)}`),
}